<template>
  <input v-model="localValue" class="appearance-none border rounded w-full px-3 py-2 text-gray-700 leading-tight focus:outline-none" type="text">
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    localValue() {
      this.$emit('input', this.localValue);
    },
  },
};
</script>

<style scoped>
.invalid input {
  @apply border-red-600;
}
</style>
